import React, { useContext } from 'react';

interface EnvironmentType {
  env: string;
}

const EnvironmentContext = React.createContext<EnvironmentType>({
  env: '',
});

export const useEnvironment = () => useContext(EnvironmentContext);

const EnvironmentProvider = ({ children }: { children: React.ReactNode }) => {
  const env =
    process.env.REACT_APP_PROD === 'true' ? 'production' : 'development';

  return (
    <EnvironmentContext.Provider value={{ env }}>
      {children}
    </EnvironmentContext.Provider>
  );
};

export default EnvironmentProvider;
